import React from "react";

export default function FilterTabs({ active, onFilter }) {
    return (
        <section id="filter-tabs" className="px-4 mb-4">
            <div className="flex space-x-2 bg-white p-1 rounded-xl shadow-sm border border-gray-100">
                <button onClick={() => onFilter("all")} className={`filter-tab flex-1 py-2 px-4 rounded-lg text-sm font-medium ${active === "all" ? "bg-primary text-white" : "text-gray-600 hover:bg-gray-50"}`}>
                    All Packages
                </button>
                <button onClick={() => onFilter("active")} className={`filter-tab flex-1 py-2 px-4 rounded-lg text-sm font-medium ${active === "active" ? "bg-primary text-white" : "text-gray-600 hover:bg-gray-50"}`}>
                    Active
                </button>
                <button onClick={() => onFilter("draft")} className={`filter-tab flex-1 py-2 px-4 rounded-lg text-sm font-medium ${active === "draft" ? "bg-primary text-white" : "text-gray-600 hover:bg-gray-50"}`}>
                    Draft
                </button>
            </div>
        </section>
    );
}
